document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementsByClassName('filter').length) {

        document.addEventListener('click', function (event) {
            if (!event.target.matches('.filter button')) return;

            var filter = event.target.dataset.filter;
            var currentButton = document.getElementsByClassName('current');
            if(currentButton) {
                currentButton[0].classList.remove('current');
            }
            event.target.classList.add('current');

            var doc = document.getElementById("filter-items");
            var eventWrappers = doc.childNodes;
            eventWrappers.forEach(function (eventWrapper) {
                eventWrapper.childNodes.forEach(function (elem) {
                    if (elem.tagName == 'DIV') {
                        if (filter == 'all') {
                            //show all
                            eventWrapper.classList.remove('hidden');
                        }
                        else if(filter == 'promoters') {
                            if (elem.dataset.promoter == '1') {
                                eventWrapper.classList.remove('hidden');
                            } else {
                                eventWrapper.classList.add('hidden');
                            }
                        }
                        else {
                            //filter elements
                            if (elem.dataset.cat == filter) {
                                eventWrapper.classList.remove('hidden');
                            } else {
                                eventWrapper.classList.add('hidden');
                            }
                        }
                    }
                });
            });
        }, false);
    }
});